"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextForm = exports.TypographyFormsBase = exports.LinkText = exports.Text = exports.TypographyBase = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("@styled-system/prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _css = _interopRequireDefault(require("@styled-system/css"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TypographyBase = _styledComponents.default.div.withConfig({
  displayName: "Typography__TypographyBase",
  componentId: "sc-1q10en5-0"
})(["", " ", " ", " ", " ", " ", ""], _styledSystem.typography, _styledSystem.color, _styledSystem.textStyle, _styledSystem.space, _styledSystem.layout, (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    nano: {
      fontSize: [0, 0, 0],
      lineHeight: [1, 1, 0]
    },
    micro: {
      fontSize: [1, 1, 1],
      lineHeight: [3, 3, 2]
    },
    tiny: {
      fontSize: [2, 2, 2],
      lineHeight: [5, 5, 4]
    },
    small: {
      fontSize: [4, 3, 4],
      lineHeight: [5, 6, 6]
    },
    medium: {
      fontSize: [5, 5, 6],
      lineHeight: [8, 6, 7]
    },
    large: {
      fontSize: [8, 7, 9],
      lineHeight: [10, 9, 13]
    },
    huge: {
      fontSize: [10, 9, 12],
      lineHeight: [12, 11, 16]
    },
    gigantic: {
      fontSize: [11, 13, 15],
      lineHeight: [14, 15, 18]
    }
  }
}));

exports.TypographyBase = TypographyBase;
TypographyBase.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _propTypes.default.color), _propTypes.default.layout), _propTypes.default.typography), _propTypes.default.textStyle), _propTypes.default.space);

var Text = function Text(props) {
  var children = props.children;
  return _react.default.createElement(TypographyBase, (0, _extends2.default)({
    as: "p",
    fontWeight: "regular",
    size: "tiny",
    color: "currentColor",
    margin: 0
  }, props), children);
};

exports.Text = Text;
var LinkStyled = (0, _styledComponents.default)(TypographyBase).withConfig({
  displayName: "Typography__LinkStyled",
  componentId: "sc-1q10en5-1"
})(function (props) {
  return (0, _css.default)({
    'text-decoration': "".concat(props.underline ? 'underline' : 'none'),
    cursor: 'pointer',
    '&:hover': {
      color: 'rambutan'
    }
  });
});

var LinkText = function LinkText(props) {
  var children = props.children;
  return _react.default.createElement(LinkStyled, (0, _extends2.default)({
    as: "a",
    href: "#",
    fontWeight: "regular",
    size: "tiny",
    color: "text.dark"
  }, props), children);
};

exports.LinkText = LinkText;

var TypographyFormsBase = _styledComponents.default.div.withConfig({
  displayName: "Typography__TypographyFormsBase",
  componentId: "sc-1q10en5-2"
})(["", " ", " ", " ", " ", " ", ""], _styledSystem.typography, _styledSystem.layout, _styledSystem.color, _styledSystem.textStyle, _styledSystem.space, (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    nano: {
      fontSize: [0, 0, 0],
      lineHeight: [1, 1, 0]
    },
    micro: {
      fontSize: [1, 1, 1],
      lineHeight: [1, 1, 1]
    },
    tiny: {
      fontSize: [2, 2, 2],
      lineHeight: [5, 5, 5]
    },
    small: {
      fontSize: [4, 3, 4],
      lineHeight: [5, 5, 5]
    },
    medium: {
      fontSize: [5, 5, 6],
      lineHeight: [8, 6, 7]
    },
    large: {
      fontSize: [8, 7, 9],
      lineHeight: [10, 9, 13]
    },
    huge: {
      fontSize: [10, 9, 12],
      lineHeight: [12, 11, 16]
    },
    gigantic: {
      fontSize: [11, 13, 15],
      lineHeight: [14, 15, 18]
    }
  }
}));

exports.TypographyFormsBase = TypographyFormsBase;
TypographyFormsBase.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _propTypes.default.color), _propTypes.default.typography), _propTypes.default.textStyle), _propTypes.default.space);

var TextForm = function TextForm(props) {
  var children = props.children;
  return _react.default.createElement(TypographyFormsBase, (0, _extends2.default)({
    as: "p",
    fontWeight: "regular",
    size: "tiny",
    color: "currentColor",
    margin: 0
  }, props), children);
};

exports.TextForm = TextForm;